import {FC, HTMLAttributes, ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

type SupersendDocumentContainerProps = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
};

const SupersendDocumentContainer: FC<SupersendDocumentContainerProps> = ({
    children,
    className,
    ...rest
}) => (
    <div
        className={twMerge(
            'p-2 rounded border border-grey-400 bg-grey-100 flex flex-wrap gap-2',
            className,
        )}
        {...rest}
    >
        {children}
    </div>
);

export default SupersendDocumentContainer;
